import * as ko from 'knockout';
import { PlayoffsVM } from './playoffs-vm';

// The legacy picker.cshtml wired up applyBindings in an inline script after
// loading the bundle.  We replicate that here so the entry point is fully
// self-contained.  Bindings are applied before the AJAX load so that KO
// observables are live when the data arrives and calls Loading(false).
document.addEventListener('DOMContentLoaded', () => {
  const vm = new PlayoffsVM();
  ko.applyBindings(vm, document.getElementById('content-wrapper')!);
  (window as any).__pp_debug = vm;
  (window as any).vm = vm;
});
